import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { InlineGridField, InlineGrid, RemoteChipInputField, RemoteChipInput } from '@components/form';

import { tasksFormOfficersGridColumns } from '@modules/tasks/_tasksColumns';

const View: React.SFC<any> = () => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <h4>Strážníci</h4>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <RemoteChipInputField
          component={RemoteChipInput}
          id="employees"
          name="employees"
          url="/metropolis/api/hr/employees"
          labelFunction={o => get(o, 'fullName')}
          fullWidth={true}
          fullWidthInput={true}
          params={{
            sorting: [
              {
                sort: 'fullName',
                order: 'ASC'
              }
            ]
          }}
        />

        <InlineGridField
          component={InlineGrid}
          name="employees"
          columns={tasksFormOfficersGridColumns}
          showCheckboxes={true}
          adding={false}
          deleting={false}
          editing={false}
        />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/tasks/TasksFormEmployees.tsx